export default class BackofficeStudyRequestsShow {
  constructor() {
    this.bindEvents();
  }

  bindEvents() {
  }

  onDataChanged(data) {
  }

  onDestroy() {
  }
}